/**
 * Conteúdo da aba Conexões no relatório.
 * Exibe conexões RADIUS: Conexões Aceitas e Tentativas de autenticação.
 * Layout alinhado à aba Financeiro: cores, espaçamentos, Paper com bordas arredondadas.
 */
import React, { useState } from 'react';
import { Box, Paper, Button, useTheme, alpha } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Security from '@mui/icons-material/Security';
import LinkOff from '@mui/icons-material/LinkOff';
import AcceptedTab from './conexoes/AcceptedTab';
import TentativasTab from './conexoes/TentativasTab';
import DesconexoesTab from './conexoes/DesconexoesTab';
import { useRelatorioCores } from './relatorioUtils';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
  </div>
);

const RelatorioConexoesTab: React.FC = () => {
  const theme = useTheme();
  const cores = useRelatorioCores();
  const [tabValue, setTabValue] = useState(0);
  const conexoesColor = cores.ativo;

  const reportTabs = [
    { key: 'aceitas', label: 'Conexões Aceitas', icon: <CheckCircle /> },
    { key: 'desconexoes', label: 'Desconexões', icon: <LinkOff /> },
    { key: 'tentativas', label: 'Tentativas', icon: <Security /> },
  ];

  return (
    <Box>
      <Paper
        elevation={2}
        sx={{
          mb: 0.1,
          borderRadius: 2,
          overflow: 'hidden'          
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            py: 1,
            px: 1,
            borderTop: `1px solid ${theme.palette.divider}`,
            bgcolor: alpha(theme.palette.background.paper, 0.6),
          }}
        >
          {reportTabs.map((tab, idx) => (
            <Button
              key={tab.key}
              variant={tabValue === idx ? 'contained' : 'outlined'}
              size="small"
              startIcon={React.cloneElement(tab.icon, {
                sx: { fontSize: 17 },
              })}
              onClick={() => setTabValue(idx)}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.82rem',
                minWidth: 160,
                ...(tabValue === idx && {
                  bgcolor: conexoesColor,
                  '&:hover': { bgcolor: alpha(conexoesColor, 0.85) },
                }),
              }}
            >
              {tab.label}
            </Button>
          ))}
        </Box>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <AcceptedTab embedded />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <DesconexoesTab embedded />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <TentativasTab embedded />
      </TabPanel>
    </Box>
  );
};

export default RelatorioConexoesTab;
